"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnDetailsTagsValue = exports.useColumnInlineTagEditor = exports.ColumnInlineTagEditor = exports.getTagNamesFromMap = exports.convertArrayToMap = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const ColumnAndFieldDetailsStyles_1 = require("../style/ColumnAndFieldDetailsStyles");
// helper function to convert a tag array into a map of tagname and tagCount.
function convertArrayToMap(tags) {
    const tagMap = new Map();
    if (tags) {
        tags.forEach(tag => {
            var _a;
            const originalTagCount = (_a = tagMap.get(tag)) !== null && _a !== void 0 ? _a : 0;
            tagMap.set(tag, originalTagCount + 1);
        });
    }
    return tagMap;
}
exports.convertArrayToMap = convertArrayToMap;
function getTagNamesFromMap(tags) {
    return Array.from(tags.keys());
}
exports.getTagNamesFromMap = getTagNamesFromMap;
function ColumnInlineTagEditor(props) {
    const { element } = useColumnInlineTagEditor(props);
    return element;
}
exports.ColumnInlineTagEditor = ColumnInlineTagEditor;
function useColumnInlineTagEditor(props) {
    const { columnLuid, onUpdate, viewOnly } = props;
    const { searchMatchingTags, updateColumnTags } = (0, catalog_core_1.useApiRequests)();
    const tags = props.tags;
    const searchMatchingTagsWrapper = react_1.default.useCallback((partialText) => searchMatchingTags({ partialText, maxItems: 5, startIndex: 0 }), [searchMatchingTags]);
    const onSave = react_1.default.useCallback((editorState) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { tagsToAdd, tagsToRemove } = (0, vizportalclient_common_components_1.getTagListsForVizportalApi)({
            oldTags: convertArrayToMap(tags),
            newTags: editorState.tags,
        });
        if (tagsToAdd.length < 1 && tagsToRemove.length < 1) {
            return;
        }
        yield updateColumnTags({ luids: [columnLuid !== null && columnLuid !== void 0 ? columnLuid : ''], tagsToAdd, tagsToRemove });
        onUpdate();
    }), [columnLuid, tags, onUpdate, updateColumnTags]);
    const logic = (0, vizportalclient_common_components_1.useInlineEditor)({
        editorStateWhenEnteringEditMode: { tags: convertArrayToMap(tags), suggestions: [], partialText: null },
        canEdit: !!props.columnLuid && props.canEditTags,
        canSaveFn: state => {
            const { tagsToAdd, tagsToRemove } = (0, vizportalclient_common_components_1.getTagListsForVizportalApi)({
                oldTags: convertArrayToMap(tags),
                newTags: state.tags,
            });
            return tagsToAdd.length > 0 || tagsToRemove.length > 0;
        },
        onSave,
    });
    return {
        element: (react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsProperty, null,
            react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, catalog_messages_1.Messages.Tags()),
            (0, vizportalclient_common_components_1.isEditMode)(logic)
                ? (react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsTableCell, null,
                    react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsTextAreaWrapper, null,
                        react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsTagsEditorWrapper, null,
                            react_1.default.createElement(vizportalclient_common_components_1.TagsEditor, { editorState: logic.editorState, setEditorState: logic.setEditorStateWithinEditMode, searchMatchingTags: searchMatchingTagsWrapper, disableEditor: logic.isActionBusy, style: { height: '100%' }, itemCount: 1 }))),
                    react_1.default.createElement(ColumnAndFieldDetailsStyles_1.SaveAndCancelButtonsWrapper, null,
                        react_1.default.createElement(SaveAndCancelButtonsFlexWrapper, null,
                            react_1.default.createElement("div", { style: { marginRight: widgets_1.TabStyles.Spacing.MediumSpace } },
                                react_1.default.createElement(vizportalclient_common_components_1.InlineEditorCancelButton, Object.assign({}, logic))),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(vizportalclient_common_components_1.InlineEditorSaveButton, Object.assign({}, logic)))))))
                : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(exports.ColumnDetailsTagsValue, null,
                        react_1.default.createElement(ReadonlyTags, { savedTags: tags })),
                    !viewOnly
                        ? react_1.default.createElement(vizportalclient_common_components_1.InlineEditorEditButton, Object.assign({}, logic, { editButtonLabel: catalog_messages_1.Messages.EditTags() }))
                        : null)))),
        startEditing: () => {
            if ((0, vizportalclient_common_components_1.isReadonlyMode)(logic)) {
                logic.enterEditMode();
            }
        },
    };
}
exports.useColumnInlineTagEditor = useColumnInlineTagEditor;
function ReadonlyTags(props) {
    return props.savedTags.length > 0
        ? (react_1.default.createElement("div", { "data-tb-test-id": 'readonly-tags', style: { maxHeight: ColumnAndFieldDetailsStyles_1.descriptionMaxHeight } }, props.savedTags.join(', ')))
        : react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsPlaceholder, null, catalog_messages_1.Messages.NoTagsAvailable());
}
exports.ColumnDetailsTagsValue = (0, vizportalclient_common_components_1.divWithStyle)('ColumnDetailsTagsValue', {
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    overflowY: 'auto',
    wordBreak: 'break-word',
});
const SaveAndCancelButtonsFlexWrapper = (0, vizportalclient_common_components_1.divWithStyle)('SaveAndCancelButtonsFlexWrapper', Object.assign(Object.assign({}, ColumnAndFieldDetailsStyles_1.SaveAndCancelButtonsFlexWrapperSharedStyle), { marginTop: widgets_1.TabStyles.Spacing.DefaultSpace }));
//# sourceMappingURL=ColumnInlineTagEditor.js.map